// @flow
import * as React from 'react';

import type { SelectProps as MuiSelectProps } from '@material-ui/core/Select';
import type { FieldProps } from 'formik';

import QSelect from 'components/QSelect';

// would be nice if we could exclude following props, not sure how or if we can in flow
//   form, checked, defaultChecked, name, onChange, value
export type SelectProps = MuiSelectProps & FieldProps & {

};

export const fieldToQSelect =
  ({
    field,
    form: { isSubmitting },
    disabled = false,
    ...props
  }: SelectProps): MuiSelectProps => {
    const { value, ...fieldProps } = field;
    return ({
      disabled: disabled || isSubmitting,
      ...props,
      ...fieldProps,
      value: value || '',
    });
  };

const handleChange = (onChange, onFieldChange) => (e, child) => {
  onChange(e);

  if (onFieldChange) {
    onFieldChange(e, child);
  }
};

const FormikQSelect: React.ComponentType<SelectProps> = (props: SelectProps) => {
  const {
    onFieldChange,
    onChange,
    ...selectProps
  } = fieldToQSelect(props);

  // There are issues with how MUI-selects handle outlined variants
  // https://github.com/mui-org/material-ui/issues/14203

  return (
    <QSelect
      onChange={handleChange(onChange, onFieldChange)}
      {...selectProps}
    />
  );
};

QSelect.displayName = 'FormikQSelect';
export default FormikQSelect;
